// extracted by mini-css-extract-plugin
export var activeDot = "_6d-c";
export var buttonContainer = "_6d-9";
export var channelButton = "_6d-a";
export var content = "_6d-0";
export var contentFull = "_6d-2";
export var contentThird = "_6d-1";
export var contentWrapper = "_6d-7";
export var description = "_6d-5";
export var image = "_6d-3";
export var imageContainer = "_6d-4";
export var selectButton = "_6d-d";
export var spinnerContainer = "_6d-b";
export var titleContent = "_6d-8";
export var titleWrapper = "_6d-6";